// extracted by mini-css-extract-plugin
export default {"microsoftLoginButton":"Microsoft_microsoftLoginButton__1ExPH"};